
























































import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import ProductDetailFlexibleSetItemCard from '~/components/pages/Product/Detail/ProductDetailFlexibleSetItemCard.vue';
import ProductDetailSetItemCartButton from '~/components/pages/Product/Detail/ProductDetailSetItemCartButton.vue';
import { useStore } from '~/composables/useStore';
import { FLEXIBLE_SET_ITEM_SECTION_ANCHOR_POINT } from '~/constants';
import { formatKeyValueArray, formatProducingArea } from '~/utils/modules/products';
import { ProductDetailSelectedFlexibleSetItem, ProductShowECResponseSchema } from '~/types/modules/product';

export default defineComponent({
  components: {
    ProductDetailSetItemCartButton,
    ProductDetailFlexibleSetItemCard,
  },
  props: {
    ecResponse: {
      type: Object as PropType<ProductShowECResponseSchema>,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const setItemVariant = computed(() => props.ecResponse.product_variants.find((variant) => variant.set_items));

    const setItems = computed(() => {
      return (
        setItemVariant.value?.set_items?.map((setItem) => {
          const {
            attributes,
            id,
            main_image_url,
            langs,
            master_settings,
            price_settings,
            review_settings,
            stock_count,
            product_variant_id,
            quantity,
            pickup_review,
            three_line_catch_copy,
          } = setItem;
          const formattedAttributes = formatKeyValueArray(attributes);
          const slicedAromas = master_settings.aromas.slice(0, 3);
          return {
            id,
            image: main_image_url,
            aromas: slicedAromas,
            brands: master_settings.brands,
            color: master_settings.color?.name,
            name: langs.find((lang) => lang.id === 'ja')?.name,
            producer: master_settings.producer?.name_kana,
            producingArea: formatProducingArea(master_settings.producing_areas),
            description: three_line_catch_copy,
            price: {
              isRed: false,
              price: price_settings.price_including_tax,
              priceExcludingTax: price_settings.price_excluding_tax,
            },
            bodyPoint: Number(formattedAttributes?.taste_gauge),
            reviews: {
              average: review_settings.rating_average,
              total: review_settings.review_total,
            },
            pickupReview: pickup_review && {
              title: pickup_review.title,
              rating: pickup_review.rating,
              body: pickup_review.body,
            },
            stockCount: stock_count,
            quantity,
            productVariantId: product_variant_id,
          };
        }) || []
      );
    });

    const totalLimit = computed(() => setItemVariant.value?.set_item_limit || 0);

    const selectedFlexibleSetItems = computed(() => store.state.product.detail.selectedFlexibleSetItems);

    const selectedTotal = computed(() =>
      selectedFlexibleSetItems.value.reduce((totalCount: number, currentItem) => totalCount + currentItem.quantity, 0)
    );

    const updateCount = (setItem: ProductDetailSelectedFlexibleSetItem) => {
      store.commit('product/detail/updateSelectedFlexibleSetItems', setItem);
    };

    return {
      totalLimit,
      selectedFlexibleSetItems,
      setItems,
      selectedTotal,
      updateCount,
      FLEXIBLE_SET_ITEM_SECTION_ANCHOR_POINT,
    };
  },
});
